import { __ } from "@wordpress/i18n";
import React from 'react';
import Hint from '../components/Hint/Hint';
import Switch from '../components/Switch/Switch';
import { useMenu } from '../contexts/MenuContext';
import withForm from '../pages/withForm';
const MoreExtra = ({handleChange}) => {
    const {
        settingData
    } = useMenu();
    return (
        <>
            <div className="setting-unit pb-lg mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Uninstall option", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center">
                                    <Hint content={__("Delete plugin data", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Delete all the plugin data upon uninstalling.", "ultimate-security")}</h6>
                                </div>
                                {/* <div className="title-group" style={{marginLeft: '30px'}}>
                                    <p className="pl-body text-text">{__("All role modifications and custom roles created using this plugin are stored in the database. If you wish to remove this data when uninstalling the plugin, please check the checkbox below. Before proceeding with the uninstallation, ensure that no users are assigned to these custom roles, as deleting this data while roles are still in use may result in technical issues.", "ultimate-security")}</p>
                                </div>                             */}
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="more.extra.enable_delete_plugin_data"
                                    checked={settingData?.more?.extra?.enable_delete_plugin_data} // Pass "1"/"0" from API 
                                    onChange={handleChange} 
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit">
                <div className="row">
                    <div className="col-lg-5">
                        
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex  ">
                                    <Hint content={__("Enable debug logging of Turnstile", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Enable debug logging of Turnstile form submission events.", "ultimate-security")}</h6>
                                </div>
                            </div>
                            <div className="col-auto">
                                <Switch 
                                    name="more.extra.enable_turnstile_debugging"
                                    checked={settingData?.more?.extra?.enable_turnstile_debugging} // Pass "1"/"0" from API 
                                    onChange={handleChange} 
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default withForm(MoreExtra,'more.extra');